<template>
  <v-dialog persistent :value="editUserModal" :width="'850'">
    <v-card>
      <popup-heading 
      :title="editUserObj.name ? editUserObj.name + ' USERS' : 'LOCATION USERS'" 
      subtitle="List of all available users for the location">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
          <v-btn
            depressed
            @click="addUserOnLocation()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>
      <v-card-text class="pop-header-fixed-content popup-height">
        <block-spinner v-if="loading"></block-spinner>
        <template v-else>
          <v-flex sm12 md12 class="nopadding-checkbox mx-2"> 
            <v-layout row wrap>
              <v-flex sm3 md4 lg4>
                <v-checkbox class="ml-3 bulk-checkbox mt-6 pl-3" color="primary" @click="bulkSelectToggle()" :label="bulk.label" v-model="bulk.value"></v-checkbox>
              </v-flex>
              <v-flex sm9 md8 lg8 class="text-sm-right">
                <v-text-field
                  class="search-input"
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout> 
          </v-flex>
          <div class="text-center mb-3">
            <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
          </div>
          <v-data-table 
            :hide-default-header="true"
            :headers="headers"
            :items="allUsersOfSelectedBusiness"
            class="pb-4 tabulardata"
            :search="search"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
           <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="item.status == 'pending' ? 'disable-event' : ''">
                <td class="text-left mr-0 pr-0" width="250">
                  <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" :value="item.id" :label="item.first_name + ' ' + item.last_name" v-model="form.users"></v-checkbox>
                </td>
                <td>
                  <div class="disable-notice">
                    <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" label="Admin" v-model="item.admin"></v-checkbox>
                    <p v-if="item.status == 'pending'">User has not accepted their invitation yet.</p>
                  </div>
                </td>
              </tr>
            </tbody>
           </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              No results.
            </v-alert>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {

  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loading: false,
      urlValidation: [
        v => !!v || 'Field is required',
        v =>
          /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(v) || 'Invalid url',
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      bulk: {
        label: 'Select All',
        value: 0,
      },
      form: {
        users: [],
      },
      headers: [
        { text: 'First Name', value: 'first_name', sortable: false, class: 'font-weight-bold'},
        { text: 'Last Name', value: 'last_name', sortable: false, class: 'font-weight-bold'},
        { text: '', value: '', sortable: false, class: 'font-weight-bold'},
      ],
      allUsersOfSelectedBusiness: [],
      allUsersOfSelectedBusinessIds: [],
      preAssignedUsers: [],
    };
  },
  computed: {
  
    ...mapGetters({
      editUserModal: 'location/editUser',
      editUserObj: 'location/editUserObj',
    }),

  },
  watch: {
    editUserObj(val) {
      if (!_.isEmpty(val)) {
        this.loading = true;
        this.getPreExistingUsers(val.id);
      }
    },
    'form.users'(val) {
      if(this.form.users.length > 0){
        if(this.form.users.length >= this.allUsersOfSelectedBusinessIds.length) {
          this.bulk =  {
            label: 'Deselect All',
            value: 1,
          };
        } else {
          this.bulk =  {
            label: 'Select All',
            value: 0,
          };
        }
      } else {
        this.bulk =  {
          label: 'Select All',
          value: 0,
        };
      }
    },
  },
  created() {
    this.closeModal();
  },
  methods: {
    /**
     * Get all users for the selected business 
     */
    getAllUsersForSelectedBusiness() {
      const url = `${Env.url}/api/v1/businesses/${ this.$store.getters.getLoggedInUserSelectedBusinessId}/users`;
      AuthApi.getApi(url)
        .then((res) => {
          let rawData = res.data.payload;
          rawData.map(item => {
            if(this.form.users.indexOf(item.id) > -1) {
              // this user is already added now get this admin value 
              item.admin = this.preAssignedUsers.filter(fitem => fitem.id == item.id)[0].admin
            } else {
               item.admin = false;
            }
          })
          this.allUsersOfSelectedBusiness = rawData;
          this.allUsersOfSelectedBusinessIds = Helper.getFieldValueInArray(res.data.payload, 'id');
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log('Unable to fetch selected location users.')
        });
    },

    /**
     * Get pre existing users for the location 
     */
    getPreExistingUsers(locationId) {
      self = this;
      const url = `${Env.url}/api/v1/locations/${locationId}/users`;
      AuthApi.getApi(url)
        .then((res) => {
          res.data.payload.map(item => {
            this.form.users.push(item.user.id);
            self.preAssignedUsers.push({
              id: item.user.id,
              admin: item.admin
            });
          })
          this.getAllUsersForSelectedBusiness();
        })
        .catch((error) => {
          this.getAllUsersForSelectedBusiness();
          console.log('Unable to fetch reexisting location users.')
        });
    },

    
     /**
     * Bulk select toggle
     */
    bulkSelectToggle() {
      if(this.bulk.value) {
        this.form.users = this.allUsersOfSelectedBusinessIds;
      } else {
        this.form.users = [];
      }
    },


    /**
     * Update location apps
     */
    addUserOnLocation() {
      this.spinner(true);
      var data = [];
      this.form.users.map(item => {
        data.push({
          user: item,
          admin: this.allUsersOfSelectedBusiness.filter( record => record['id'] === item)[0]['admin'],
        })
      })
      const url = `${Env.url}/api/v1/locations/${ this.editUserObj.id }/users`;
      AuthApi.postApi(url, { users: data})
        .then((res) => {
          this.spinner(false);
          this.snackbar({
            text: `Successfully added users on ${this.editUserObj.name}.`,
            timeout: 4000,
            open: true,
          });
          this.closeModal();
        })
        .catch((err) => {
          this.snackbar({
            text: err.response.data.msg ? err.response.data.msg : 'Please try again later',
            timeout: 4000,
            open: true,
          });
          this.spinner(false);
        });
    },
    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      const self = this;
      this.spinner(false);
      this.setEditUser(false);
      this.setEditUserObj({});
      this.form.users = [];
      this.preAssignedUsers = [];
      this.form.admin = false;
      this.search = '';
      this.bulk =  {
        label: 'Select All',
        value: 0,
      };
    },

    ...mapActions({
      setEditUser: 'location/setEditUser',
      setEditUserObj: 'location/setEditUserObj',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

